import React, { useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import ButtonYesno from "../../../components/buttons/button.yesno";
import ButtonTVA from "../../../components/buttons/button.txTVA";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";

// Crédit-bail : Cession du contrat de crédit-bail sans stipulation de prix
// Id simulateur 38

function Simulateur_38(props) {
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const [departement, setDepartement] = useState(0);
  const [montant_investissement, setMontantInvestissement] = useState(0);
  const [duree_bail, setDuree] = useState(0);
  const [nombre_copie_executoire, setCopieExecutoire] = useState(0);
  const [montant_loyer_mensuel_ht, setMontantLoyer] = useState(0);
  const [loyer_tva, setLoyerTva] = useState(0);
  const [loyer_taux_tva, setLoyerTvaTaux] = useState(0);
  const [montant_frais_financier, setMontantFinancier] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);

  const handleChange = async (setter, value, key) => {
    if (setter === setDepartement) {
      setDepartement(parseInt(value));
    } else setter(value);
    setInRedux(setter, value, key);
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  function setInRedux(setter, value, key) {
    if (props.isParent) {
      let object = {
        simulateurid: props.simulateur.id,
        departementid: parseInt(departement),
        inputs: {
          montant_investissement: parseInt(montant_investissement),
          duree_bail: parseInt(duree_bail),
          nombre_copie_executoire: parseInt(nombre_copie_executoire),
          montant_loyer_mensuel_ht: parseInt(montant_loyer_mensuel_ht),
          loyer_tva: parseInt(loyer_tva),
          loyer_taux_tva: parseFloat(loyer_taux_tva),
          montant_frais_financier: parseInt(montant_frais_financier),
          montant_deb_add: parseInt(montantDeboursAdditionnels),
          debours_additionnels: parseInt(deboursAdditionnels),
          convention_honoraires : parseInt(props.conventionHonoraires),
        },
        pdfInputs: {
          nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
          object_convention_honoraires : props.objectConventionHonoraires,
          montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
          nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
          adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
        },
      };

      //For values coming from components
      if (key) {
        if (key === "debours_additionnels") {
          if (value === 0) {
            setMontantDeboursAdditionnels(0)
            Object.assign(object["inputs"], { montant_deb_add: parseInt(0) });
          }
          Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
        }
        if (key === "montant_deb_add") {
          Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
        }
      }
      //For internal settings

      if (setter === setDepartement) {
        object.departementid = parseInt(value);
      }

      if (setter === setMontantInvestissement) {
        Object.assign(object["inputs"], { montant_investissement: parseInt(value) });
      }

      if (setter === setDuree) {
        Object.assign(object["inputs"], { duree_bail: parseInt(value) });
      }

      if (setter === setCopieExecutoire) {
        Object.assign(object["inputs"], { nombre_copie_executoire: parseInt(value) });
      }

      if (setter === setMontantLoyer) {
        Object.assign(object["inputs"], { montant_loyer_mensuel_ht: parseInt(value) });
      }

      if (setter === setLoyerTva) {
        Object.assign(object["inputs"], { loyer_tva: parseInt(value) });
        // Si loyer_tva passe à 0, effacer aussi loyer_taux_tva
        if (parseInt(value) === 0) {
          Object.assign(object["inputs"], { loyer_taux_tva: 0 });
        }
      }

      if (setter === setLoyerTvaTaux) {
        Object.assign(object["inputs"], { loyer_taux_tva: parseFloat(value) });
      }

      if (setter === setMontantFinancier) {
        Object.assign(object["inputs"], { montant_frais_financier: parseInt(value) });
      }

      if (setter === props.setConventionHonoraires) {
        if(value === 0){
          props.setNombreConventionHonoraires(1);
          props.setObjectConventionHonoraires(null);
          props.setMontantConventionHonoraires(null);
          props.setNomSignataireConventionHonoraires(null);
          props.setAdresseSignataireConventionHonoraires(null);
          Object.assign(
            object["inputs"], { convention_honoraires : parseInt(value) },
            object["pdfInputs"], {
              nombre_convention_honoraires : null,
              object_convention_honoraires : null,
              montant_convention_honoraires : null,
              nom_signataire_convention_honoraires : null,
              adresse_signataire_convention_honoraires : null
            },
          );
        } else {
          Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
        }
      }

      if (setter === props.setNombreConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) });
      }

      if (setter === props.setObjectConventionHonoraires) {
        Object.assign(object["pdfInputs"], { object_convention_honoraires : value });
      }

      if (setter === props.setMontantConventionHonoraires) {
        Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)});
      }

      if (setter === props.setNomSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
      }

      if (setter === props.setAdresseSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
      }


      dispatch(setSimulateurObject(object));
    } else {
      // process child simu
    }
  }

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        <p style={styles.cardSubTitle}>Acte tarifé au titre du Tableau 5, n° 116 (Art A444-132)</p>

        {props?.isParent === true && props.departements !== "" ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Département :</div>

            <SelectDepartement
              items={props.departements}
              nameField={"name"}
              defaultValue={currUserDep}
              optionValue={"id"}
              handleChange={handleChange}
              setter={setDepartement}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Quel est le montant total de l’investissement ?</div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setMontantInvestissement}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Quelle est la durée (en année) du contrat de crédit-bail ?</div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer la durée"}
            setter={setDuree}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Quel est le nombre de page(s) de la copie exécutoire ?</div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le nombre"}
            setter={setCopieExecutoire}
          />
        </div>

        {parseInt(duree_bail) > 11 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Quel est le montant HT mensuel des loyers ?</div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontantLoyer}
            />
          </div>
        ) : (
          <></>
        )}

        {parseInt(duree_bail) > 11 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Les loyers sont-ils soumis à TVA ?</div>
            <div>
              <ButtonYesno handleChange={handleChange} setter={setLoyerTva} fieldUndefined={false} defaultValue={0} />
            </div>
          </div>
        ) : (
          <></>
        )}

        {parseInt(loyer_tva) === 1 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>A quel taux de TVA ?</div>
            <ButtonTVA handleChange={handleChange} setter={setLoyerTvaTaux} fieldUndefined={false} defaultValue={1} />
          </div>
        ) : (
          <></>
        )}

        {parseInt(duree_bail) > 11 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Quel est le montant des frais financiers indiqués dans l’acte ?
            </div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontantFinancier}
            />
          </div>
        ) : (
          <></>
        )}

        <DeboursQuestion
            handleChange={handleChange}
            deboursAdditionnels={deboursAdditionnels}
            setDeboursAdditionnels={setDeboursAdditionnels}
            setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
        />

        <ConventionHonoraires
          handleChange={handleChange}
          conventionHonoraires={props.conventionHonoraires}
          setConventionHonoraires={props.setConventionHonoraires}
          nombreConventionHonoraires={props.nombreConventionHonoraires}
          setNombreConventionHonoraires={props.setNombreConventionHonoraires}
          objectConventionHonoraires={props.objectConventionHonoraires}
          setObjectConventionHonoraires={props.setObjectConventionHonoraires}
          montantConventionHonoraires={props.montantConventionHonoraires}
          setMontantConventionHonoraires={props.setMontantConventionHonoraires}
          nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
          setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
          adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
          setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
      </div>
    </div>
  );
}

export default Simulateur_38;
